


















import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class IconStopSale extends Vue {
  @Prop({default: 25}) public readonly width!: number;
  @Prop({default: 25}) public readonly height!: number;
}
